import {Button, FC, useMemo} from 'external/react'

import {isDiscounted, Offer} from '../../../types/offer'

import OfferDiscountHeader from './OfferDiscountHeader'
import OfferHeader from './OfferHeader'
import { notifySuccess, showConfirmDialog } from 'components/Notify'
import usePayment from 'context/payment-context/hook'
import usePublic from 'context/public-context/hook'

export type OfferSummaryProps = {
	offer: Offer
}

const OfferSummary: FC<OfferSummaryProps> = (props) => {

	const {offer} = props
	const {emptyCart, packageStatus} = usePayment()
	const {navigation} = usePublic()
	
	const [Header, listing] = useMemo(() => {
		const Header = isDiscounted(offer) ? OfferDiscountHeader : OfferHeader
		return [Header, <div dangerouslySetInnerHTML={{__html: offer.content.html}} />]
	}, [offer])

	async function handleOfferSelection() {
		if (!packageStatus.notFound && packageStatus.coursesCount > 0) {
			const {isConfirmed} = await showConfirmDialog('¿Ya tiene un paquete en el carrito, desea reemplazarlo?')
			if (!isConfirmed) return
			await emptyCart()
			notifySuccess('Se vacio el carrito.')
		}
		navigation.offer.go({offerId: offer.id})
	}

	return (
		<div className='card'>
			<div className='cardHeader' style={{ height: '110px' }}>
				<Header offer={offer} />
			</div>

			<div className='cardBody'>
				<div className='offerList'>
					{listing}
				</div>
			</div>
			<div className='cardFooter'>
				<Button variant='outline-primary w-100' onClick={handleOfferSelection}>
					Escoger
				</Button>
			</div>
		</div>
	)
}

export {OfferSummary as default}